var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.8 16.97c.337.12.7-.131.7-.493V4.48a.437.437 0 0 0-.156-.35C8.73 3.637 7.325 3 5.5 3c-1.578 0-3.053.423-3.934.766-.354.14-.566.496-.566.88v11.77c0 .378.4.642.753.525.984-.334 2.544-.719 3.747-.719 1.06 0 2.469.445 3.3.747Zm2.4 0c.831-.303 2.24-.748 3.3-.748 1.203 0 2.762.385 3.747.719.353.12.753-.146.753-.525V4.646c0-.384-.212-.74-.566-.877C17.554 3.423 16.078 3 14.5 3c-1.825 0-3.231.636-3.844 1.132a.447.447 0 0 0-.156.35v11.995c0 .362.366.613.7.492Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/book-open.be21477949a61498d929eacdaf953984.svg";